import { 
	SET_PAGE_TITLE, 
	SET_BODY_CLASS, 
	SHOW_APP_LOADER, 
	HIDE_APP_LOADER, 
	HIDE_MOBILE_NAV
} from './mutation-types';

export default {
	[SET_PAGE_TITLE] (state, title) {
		document.title = `${title} - Ezi Food`;
		state.currentPageTitle = title
	},

	[HIDE_MOBILE_NAV] (state) {
		let html = document.querySelector('html');

		if (html) {
			html.classList.remove('nav-open');
			gaia.misc.navbar_menu_visible = 0		
		}
	},

	[SET_BODY_CLASS] (state, newClass) {
		state.bodyClass = newClass;
		document.querySelector('body').className = state.bodyClass;
	},

	[SHOW_APP_LOADER] (state) {
		state.showLoader = true;
	},

	[HIDE_APP_LOADER] (state) {
		state.showLoader = false;
	}
}


// WEBPACK FOOTER //
// ./src/store/mutations.js